import React from 'react'
import './style.scss'
import ListItemDetailed from '~/components/ListItemDetailed'
import { getFollows } from "~/redux/user/follows";
import {BackArrowIcon } from '~/assets/svg';
import Spinner from '~/components/Spinner';
import _ from 'lodash';

class Following extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            conceptList: [],
            title: _.get(this.props.data, 'title', ''),
            loadingConcepts: true
        }
    }
    componentDidMount() {
        getFollows('SERIES').then((data) => {
            data = data.records;
            data.map((key, index) => {
                data[index].contentDetails.gist['id'] = data[index].contentDetails.id;
            });
            this.setState({
                conceptList: data,
                loadingConcepts: false
            })
        })
    }

    goBack() {
        window.history.back();
    }

    render() {
        return (
            <div className='following-module'>
                <div className="module-header">
                    <div className="left">
                        <a onClick={this.goBack} className="back-arrow"><BackArrowIcon/></a>
                    </div>
                    {this.state.title.toUpperCase()}
                </div>
                <div className="detailed-item-list">

                {this.state.loadingConcepts && <Spinner />}

                {this.state.conceptList.length > 0 && (
                    this.state.conceptList.map(item => (
                        <ListItemDetailed key={item.contentDetails.id} 
                            item={item} 
                            hideAuthor={true} 
                            showChevron={true} 
                            isFollowingModule={true}/>
                    ))
                )}
                {!this.state.loadingConcepts && !this.state.conceptList.length && (
                    <div className="no-items">
                        <span>Follow concepts you like for a shortcut to their latest content</span>
                        <div className="browse-button"><a href="/conceptLandingPage">Browse Concepts</a></div>
                    </div>
                )}
                </div>
            </div>
        )
    }
}

export default Following;
